import { render, staticRenderFns } from "./ModelDetails.vue?vue&type=template&id=0ad07254&scoped=true"
import script from "./ModelDetails.vue?vue&type=script&lang=js"
export * from "./ModelDetails.vue?vue&type=script&lang=js"
import style0 from "./ModelDetails.vue?vue&type=style&index=0&id=0ad07254&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad07254",
  null
  
)

export default component.exports